<template>
  <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
    <div class="row mb-3 mt-3">
      <div class="col-md-4">
        <v-select
          v-if="$role == 'super_admin'"
          v-model="eduProgramId"
          :options="eduPrograms"
          class="w-100"
          label="name"
          :reduce="(item) => item.id"
          @input="changeEduPrograms(eduProgramId)"
        />
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <input
            type="text"
            autofocus
            class="form-control"
            v-model="search"
            @input="(val) => searchChange(val)"
            :placeholder="$t(`site.search`)"
          />
        </div>
      </div>
      <div class="col-3">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown
            id="ddown2"
            right
            :text="`${perPage}`"
            variant="outline-warning"
            size="xs"
          >
            <b-dropdown-item
              v-for="(size, index) in [5, 10, 20, 50, 100]"
              :key="index"
              @click="changePageSize(size)"
              >{{ size }}</b-dropdown-item
            >
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table
          :stacked="$mobile == 1"
          ref="table"
          class="vuetable"
          sort-by="id"
          sort-desc.sync="false"
          :current-page="currentPage"
          :fields="bootstrapTable.fields"
          :items="dataProvider"
        >
          <template #cell(checkbox)="data">
            <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
              <input
                type="checkbox"
                v-model="recordIds"
                :value="data.item.id"
                @change="selectItem(data)"
              />
              <span></span>
            </label>
          </template>
          <template #cell(reference_no)="data"
          >{{ data.item.users_for_api.reference_no }}
        </template>
          <template #cell(status_id)="data"
            >{{ data.item.master_status.name }}
          </template>
          <template #cell(student_id)="data">
            <b-badge variant="light-warning">
              {{ data.item.student.full_name }}
            </b-badge>
          </template>
          <!-- <template #cell(edu_program_id)="data">
            <b-badge variant="light-info">
              {{ data.item.edu_program.name }}
            </b-badge>
          </template> -->
          <template #cell(teacher)="data">
            <b-badge variant="light-info">
              {{ supervisor(data.item.teachers ) }}
            </b-badge>
          </template>
          <template #cell(supervising)="data">
            <b-btn
              variant="outline-warning"
              block
              :to="{
                name: 'ThesisAdmin',
                params: {
                  userId: data.item.student.id,
                  masterId: data.item.id,
                },
              }"
              >{{ $t("activities.activities") }}</b-btn
            >
          </template>
          <template #cell(supervisor)="data">
            <b-button
            v-if="$role != 'teacher' && $role != 'student'"
              block
              variant="outline-info"
              :to="{
                name: 'AssignSupervisors',
                params: {
                  master_id: data.item.id,
                },
              }"
              >{{ $t("master.set_supervisors") }}</b-button
            >
          </template>

          <b-spinner
            v-if="load"
            type="grow"
            label="Loading..."
            class="loading"
          />
        </b-table>

        <b-pagination
          align="right"
          class="dataTables_paginate paging_simple_numbers"
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
        >
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
  </div>
</template>

<script>
import controller from "../../../../Controllers/MastersController";
import config from "../../../../config/config";
import Auth from "@/Apis/Auth";
import vSelect from "vue-select";
import EduProgramsController from "@/Controllers/EduProgramsController";

export default {
  name: "MastersDataTable",
  props: ["items", "editItem"],
  components: {
    vSelect,
  },
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          {
            key : "reference_no",
            label : "الرقم المرجعي"
          },
          
          {
            key: "student_id",
            label: this.$i18n.t("master.student"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "title",
            label: this.$i18n.t("master.title"),
            sortable: true,
            sortDirection: "desc",
          },

          {
            key: "teacher",
            label: this.$i18n.t("master.specific_master_teacher"),
          },
          {
            key: "status_id",
            label: this.$i18n.t("master.status"),
            sortable: true,
            sortDirection: "desc",
          },
          // {
          //   key: "edu_program_id",
          //   label: this.$i18n.t("master.status"),
          //   sortable: true,
          //   sortDirection: "desc",
          // },

          {
            key: "supervising",
            label: this.$i18n.t("master.supervising_the_message"),
          },
          

          {
            key: "supervisor",
            label: this.$i18n.t("master.supervisors"),
          },
        ],
      },
      data: {},
      selectAll: false,

      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      user: Auth.USER,
      eduPrograms: [],
      eduProgramId: 0,
    };
  },
  async created() {
    if (Auth.USER.account_type == "teacher") {
      this.bootstrapTable.fields.splice(4, 1);
      this.bootstrapTable.fields.push({
        key: "supervising",
        label: this.$i18n.t("master.supervising_the_message"),
      });
      this.eduProgramId = localStorage.getItem("eduProgram");
    } else {
      this.eduPrograms = await new EduProgramsController().GetAll({
        filter: "is_master|1",
      });
    }
  },
  methods: {
    getTypeTeacher(item) {
      const teacher = item.teachers.find((a) => a.id == Auth.USER.id);
      if (teacher) return this.$i18n.t("master." + teacher.pivot.type);
      return "";
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    changeEduPrograms() {
      this.$refs.table.refresh();
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;

      const data = await new controller().GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }

      apiParams.with = ["master_status", "teachers", "student", "eduProgram","usersForApi"];
      if (this.eduProgramId != 0)
        apiParams.filter = "edu_program_id|" + this.eduProgramId;

      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      // this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        // this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      // this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    deleteItem(data) {
      new controller().Delete(data.item.id, [], this.$refs.table);
    },
    multiDelete() {
      new controller().Delete(0, this.recordIds, this.$refs.table);
    },
    supervisor(teachers) {
      //find supervisor from the pivot
      const supervisor = teachers.find((a) => a.pivot.type == "supervisor");
      if (supervisor) return supervisor.full_name;
      return "";
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>